const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  orderState: state => state.app.orderState,
  couponState: state => state.app.couponState,
  onlineType: state => state.app.onlineType,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  cusid: state => state.user.cusid,
  name: state => state.user.name,
  mobile: state => state.user.mobile,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  goodsType: state => state.goods.goodsType,
  temporaryType: state => state.goods.temporaryType,
  effectiveDuration: state => state.goods.effectiveDuration,
  monthType: state => state.goods.monthType,
  operatorType: state => state.goods.operatorType,
  cardState: state => state.card.cardState,
  wifiState: state => state.wifi.wifiState,
  operatoricons: state => state.card.operatoricons,
  cuserPhone: state => state.settings.cuserPhone,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js